import { FinishPackageSubmissionInteractiveTaskDefinition } from './FinishPackageSubmissionInteractiveTask'
import { IInteractiveWorkflowTask } from './IInteractiveWorkflowTask'
import { PostFormPackageSubmitRedirectTaskDefinition } from './PostFormPackageSubmitInteractiveTask'
import { RequestFileInteractiveTaskDefinition } from './RequestFileInteractiveTask'

let registryInitialized = false

export function getGlobalInteractiveWorkflowTaskRegistry(): GlobalInteractiveWorkflowTaskRegistryType {
	if (!registryInitialized) initialize()
	return GlobalInteractiveWorkflowTaskRegistryObject
}

function initialize() {
	registryInitialized = true

	GlobalInteractiveWorkflowTaskRegistryObject.workflowTaskCollection = {
		[FinishPackageSubmissionInteractiveTaskDefinition.id]:
			FinishPackageSubmissionInteractiveTaskDefinition,
		[PostFormPackageSubmitRedirectTaskDefinition.id]:
			PostFormPackageSubmitRedirectTaskDefinition,
		[RequestFileInteractiveTaskDefinition.id]:
			RequestFileInteractiveTaskDefinition,
	} as InteractiveWorkflowTaskRegistryDictionary
}

type GlobalInteractiveWorkflowTaskRegistryType = {
	workflowTaskCollection: Record<string, IInteractiveWorkflowTask>
}

type InteractiveWorkflowTaskRegistryDictionary = Record<
	string,
	IInteractiveWorkflowTask
>

const GlobalInteractiveWorkflowTaskRegistryObject: GlobalInteractiveWorkflowTaskRegistryType =
	{
		workflowTaskCollection: {} as InteractiveWorkflowTaskRegistryDictionary,
	}
